const regex = /([A-Z])([A-Z])([a-z])|([a-z])([A-Z])/g;
const decamelizeString = (string) =>
  string
    .replace(regex, "$1$4 $2$3$5")
    .replace(/^./, (match) => match.toUpperCase());

export default decamelizeString;
